{
  "default": "/home",
  "rules": [
    { "type": "exact",  "value": "dashboard.self.com.br", "route": "/dashboard" },

    { "type": "suffix", "value": ".ddo.dental", "route": "/ddo" },
    { "type": "suffix", "value": "iorthopay.com", "route": "/i" },

    { "type": "prefix", "value": "iorthopay.", "route": "/i" },
    { "type": "prefix", "value": "www.iorthopay.", "route": "/i" },

    { "type": "prefix", "value": "aditek.", "route": "/home" },

    { "type": "regex",  "value": "^(?<tenant>[a-z0-9-]+)\\.ddo\\.dental$", "routeTemplate": "/t/{tenant}" },

    { "type": "regex",  "value": "^[a-z0-9-]+\\.staging\\.self\\.com\\.br$", "route": "/staging" }
  ]
}

